export default {
    getNumeroCelularCompleto: state => {
        return `55${state.perfil.dddDoWhatsApp}${state.perfil.numeroDoWhatsApp}` 
    },
    getLocalDeEstoqueId: state => state.perfil?.localDeEstoqueId,
    getQuantidadeMinimaEstoqueExibicao: state => state.perfil?.quantidadeMinimaEstoqueExibicao || 0
}